// extracted by mini-css-extract-plugin
export default {"suspensePreloader":"suspensePreloader_suspensePreloader__GElAZ","spinner":"suspensePreloader_spinner__RoBgC"};